import React from 'react';
import { Routes, Route } from 'react-router';
import { ROUTES } from '../constants/routes';
import loadable from '@loadable/component';
import ChairpersonGate from '../screens/ChairpersonGate';

/* eslint-disable @typescript-eslint/no-explicit-any */
const Home = loadable(() =>
  import(/* webpackChunkName: "HomeChunk" */ '../screens/Home')
) as React.ComponentType<any>;
const Setup = loadable(() =>
  import(/* webpackChunkName: "SetupChunk" */ '../screens/Setup')
) as React.ComponentType<any>;
const Adjudicator = loadable(() =>
  import(/* webpackChunkName: "AdjudicatorChunk" */ '../screens/Adjudicator')
) as React.ComponentType<any>;
const Current = loadable(() =>
  import(/* webpackChunkName: "CurrentChunk" */ '../screens/Current')
) as React.ComponentType<any>;
const MCComponent = loadable(() =>
  import(/* webpackChunkName: "MCComponentChunk" */ '../screens/MCComponent')
) as React.ComponentType<any>;
const MonitorScreen = loadable(() =>
  import(/* webpackChunkName: "MonitorScreenChunk" */ '../screens/MonitorScreen')
) as React.ComponentType<any>;
const LEDScreen = loadable(() =>
  import(/* webpackChunkName: "LEDScreenChunk" */ '../screens/LEDScreen')
) as React.ComponentType<any>;
const BroadcastScreen = loadable(() =>
  import(/* webpackChunkName: "BroadcastScreenChunk" */ '../screens/BroadcastScreen')
) as React.ComponentType<any>;
const VisualController = loadable(() =>
  import(/* webpackChunkName: "VisualControllerChunk" */ '../screens/VisualController')
) as React.ComponentType<any>;
const TrainingLauncher = loadable(() =>
  import(/* webpackChunkName: "TrainingChunk" */ '../screens/TrainingLauncher')
) as React.ComponentType<any>;
/* eslint-enable @typescript-eslint/no-explicit-any */

interface AppRoutesProps {
  scrollRef?: React.RefObject<HTMLDivElement>;
  scrollToBottom?: () => void;
  appBarHeight?: number;
}

const AppRoutes: React.FC<AppRoutesProps> = ({ scrollRef, scrollToBottom, appBarHeight }) => {
  return (
    <Routes>
      <Route path={ROUTES.HOME} element={<Home appBarHeight={appBarHeight} />} />
      <Route path={ROUTES.SETUP} element={<Setup appBarHeight={appBarHeight} />} />
      <Route path={ROUTES.ADJUDICATOR} element={<Adjudicator />} />
      <Route path={ROUTES.CURRENT} element={<Current scrollRef={scrollRef} scrollToBottom={scrollToBottom} appBarHeight={appBarHeight} />} />
      <Route path={ROUTES.MC} element={<MCComponent appBarHeight={appBarHeight} />} />
      <Route
        path={ROUTES.CHAIRPERSON}
        element={
          <ChairpersonGate>
            <MCComponent appBarHeight={appBarHeight} />
          </ChairpersonGate>
        }
      />
      <Route path={ROUTES.DJ} element={<MCComponent appBarHeight={appBarHeight} />} />
      <Route path={ROUTES.FLOOR_MANAGER} element={<MCComponent appBarHeight={appBarHeight} />} />
      <Route path={ROUTES.MONITOR} element={<MonitorScreen appBarHeight={appBarHeight} />} />
      <Route path={ROUTES.LED_SCREEN} element={<LEDScreen />} />
      <Route path={ROUTES.BROADCAST_SCREEN} element={<BroadcastScreen />} />
      <Route path={ROUTES.VISUAL_CONTROLLER} element={<VisualController />} />
      <Route path={ROUTES.TRAINING} element={<TrainingLauncher />} />
      <Route path={ROUTES.TRAINING_SYSTEM} element={<TrainingLauncher />} />
      <Route path={ROUTES.TRAINING_ROUND} element={<TrainingLauncher />} />
    </Routes>
  );
};

export default AppRoutes;
